module.exports = __webpack_public_path__ + "static/homepage3-77e46259f783c03256e6dbcc762f3194.png";